const AydinlatmaMetni = (props) => {
  return (
    <>
      <div
        className="modal fade fixed top-0 left-0 hidden w-full h-full outline-none overflow-x-hidden overflow-y-auto"
        id="aydinlatmaMetni"
        tabIndex="-1"
        aria-labelledby="aydinlatmaMetniLabel"
        aria-modal="true"
        role="dialog"
      >
        <div className="modal-dialog modal-lg relative w-auto pointer-events-none">
          <div className="modal-content border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
            <div className="modal-body relative p-4 space-y-4">
              <h4 className="text-gray-800 font-semibold text-center">
                KVKK
                <br /> KİŞİSEL VERİLERİNİZE DAİR HAKLARINIZ VE AYDINLATMA METNİ{" "}
                <br />
                TOPLANAN KİŞİSEL VERİLERİNİZLE İLGİLİ HAKLARINIZ
              </h4>
              <div className="w-full flex flex-col text-gray-900 space-y-1">
                <p className="text-gray-900 text-xs md:text-sm">
                  Veri sahibi, işlenen Kişisel Verileri’nin neler olduğunu ve
                  işlenip işlenmediğini, işleme amacı doğrultusunda kullanılıp
                  kullanılmadığını öğrenebilir, verileri işlenmişse bu hususta
                  bilgi talep edebilir, yurt içi veya yurt dışında Kişisel
                  Veriler’in aktarıldığı üçüncü kişileri öğrenebilir, eksik veya
                  yanlış işlenen Kişisel Veriler söz konusu ise veya işlenen
                  Kişisel Verileri’nde herhangi bir değişiklik olması durumunda
                  bu verilerin düzeltilmesini, değiştirilmesini,
                  güncellenmesini, KVKK’nın 7. maddesinde öngörülen şartlar
                  çerçevesinde silinmesini/yok edilmesini veya anonim hale
                  getirilmesini, bu işlemlerin (eksik veya yanlış işlenen
                  Kişisel Verileri söz konusu ise, bu verilerin düzeltilmesini
                  veya KVKK’nın 7. maddesinde öngörülen şartlar çerçevesinde
                  silinmesini/yok edilmesini veya anonim hale getirilmesini)
                  Kişisel Veriler’in aktarıldığı üçüncü kişilere bildirilmesini
                  talep edebilir; işlenen verilerin münhasıran otomatik
                  sistemler ile analiz edilmesi nedeniyle aleyhine bir sonucun
                  ortaya çıkmasına itiraz edebilir ve Kişisel Veriler’in kanuna
                  aykırı olarak işlenmesi sebebiyle zarara uğraması hâlinde
                  zararın giderilmesini talep edebilir. Kullanıcı/Üye, bu
                  kapsamdaki haklarını KVKK md. 11 uyarınca:
                </p>
                <ul className="text-xs md:text-sm list-disc pl-10">
                  <li>
                    3İK Marka İletişim Ajansı’nın hakkınızda kişisel veri
                    işleyip işlemediğini öğrenmek, eğer işlemişse, buna ilişkin
                    bilgi talep etmek,
                  </li>
                  <li>
                    Kişisel verilerinizin işlenme amacını ve bunların amacına
                    uygun kullanılıp kullanılmadığı öğrenmek,
                  </li>
                  <li>
                    Kişisel verilerin yurtiçi veya yurtdışına aktarılıp
                    aktarılmadığı ve kimlere aktarıldığını öğrenmek haklarına
                    sahipsiniz.
                  </li>
                  <li>
                    Ayrıca, 3İK Marka İletişim Ajansı’ndan yanlış ve eksik
                    kişisel verilerinizin düzeltilmesini ve verilerinin
                    aktarıldığı veya aktarılmış olabileceği alıcıların
                    bilgilendirilmesini talep etme hakkınız vardır.
                  </li>
                </ul>
                <p className="text-xs md:text-sm">
                  Kişisel verilerinizin KVKK madde 7’de öngörülen şartlar
                  çerçevesinde verilerinizin imha edilmesini (silinmesini, yok
                  edilmesini veya anonim hale getirilmesini) 3İK Marka İletişim
                  Ajansı’ndan talep edebilirsiniz. Aynı zamanda verilerin
                  aktarıldığı veya aktarılabileceği 3. kişilerin söz konusu imha
                  talebiniz ile ilgili bilgilendirilmesini talep edebilirsiniz.
                  Ancak imha talebinizi değerlendirerek hangi yöntemin uygun
                  olduğu somut olayın koşullarına göre tarafımızca
                  değerlendirilecektir. Bu bağlamda seçtiğimiz imha yöntemini
                  neden seçtiğimiz ile ilgili bizden her zaman bilgi talep
                  edebilirsiniz. Münhasıran bir otomatik sistem kullanılarak
                  oluşturulmuş kişisel veri analizinizin sonuçlarına bu sonuçlar
                  çıkarlarınıza aykırıysa itiraz edebilirsiniz. Kişisel
                  verilerinizin kanuna aykırı olarak işlenmesi sebebiyle zarara
                  uğramanız halinde zararın giderilmesini talep edebilirsiniz.
                  Başvurunuzda yer alan talepleriniz, talebin niteliğine göre en
                  geç otuz gün içinde ücretsiz olarak sonuçlandırılacaktır.
                  Ancak, işlemin 3İK Marka İletişim Ajansı için ayrıca bir
                  maliyeti gerektirmesi hâlinde, Kişisel Verileri Koruma Kurulu
                  tarafından Veri Sorumlusuna Başvuru Usul ve Esasları Hakkında
                  Tebliğ’de belirlenen tarifedeki ücret alınabilir.
                  <br />
                  Kişisel verilerinizin işlenmesi ile ilgili hususlarda
                  başvurunuzu, bu Aydınlatma Metni’ nin ekinde yer alan başvuru
                  formunu doldurarak, yazılı olarak veya kayıtlı elektronik
                  posta (KEP) adresi, güvenli elektronik imza, mobil imza ya da
                  bize daha önce bildirdiğiniz ve kayıtlarımızda yer alan
                  elektronik posta adresinizi kullanmak suretiyle 3İK Marka
                  İletişim Ajansı’na teslim etmeniz gerekmektedir. 3İK Marka
                  İletişim Ajansı tarafından talebinizin mahiyetine ve başvuru
                  yönteminize göre 3İK Marka İletişim Ajansı tarafından
                  başvurunun size ait olup olmadığının belirlenmesi ve böylece
                  haklarınızı koruyabilmek amacıyla ek doğrulamalar (kayıtlı
                  telefonunuza mesaj gönderilmesi, aranmanız gibi) istenebilir.
                  Örneğin 3İK Marka İletişim Ajansı’nda kayıtlı olan e-posta
                  adresiniz aracılığıyla başvuru yapmanız halinde 3İK Marka
                  İletişim Ajansı’nda kayıtlı başka bir iletişim yöntemini
                  kullanarak size ulaşabilir ve başvurunun size ait olup
                  olmadığının teyidini isteyebiliriz.
                </p>
              </div>
              <div>
                <h4 className="text-gray-800 font-semibold text-left">
                  KİŞİSEL VERİ SAKLAMA SÜRESİ
                </h4>
                <p className="text-xs md:text-sm">
                  Şirketimiz, KVKK uyarınca işlediği Kişisel Verileri yalnızca
                  ilgili mevzuatta öngörülen veya mevzuatta bir süre
                  öngörülmemiş ise kişisel veri işleme amacının gerektirdiği
                  süre kadar muhafaza eder. Tutulan veriler verinin işlenmesini
                  gerektiren sebepler sona erdikten sonra silinir, yok edilir
                  veya anonim hale getirilir. Örnek vermek gerekirse 6563 Sayılı
                  Elektronik Ticaretin Düzenlenmesi Hakkında Kanun ile buna
                  bağlı yönetmelik uyarınca Kişisel Veriler’in pazarlama veya
                  tanıtım amaçları için kullanılacağına ilişkin veri sahibinin
                  onayının geri alındığı durumlarda, Kişisel Veriler’in
                  kayıtları bu tarihten itibaren 1 yıl saklanır. Ticari
                  elektronik iletinin içeriği ve gönderiye ilişkin diğer her
                  türlü kayıt ise gerektiğinde ilgili bakanlığa sunulmak üzere 3
                  yıl saklanır. 5651 Sayılı İnternet Ortamında Yapılan
                  Yayınların Düzenlenmesi ve Bu Yayınlar Yoluyla İşlenen
                  Suçlarla Mücadele Edilmesi Hakkında Kanun uyarınca ise
                  işlediğimiz trafik verileri 2 yıl saklanır ve süre bittikten
                  sonra anonim hale getirilir. Her halükarda Kişisel Veriler’in
                  birden fazla sebeple işlenmiş olması halinde, söz konusu
                  verinin işlenmesini gerektiren tüm nedenler ortadan
                  kalktığında ilgili veri silinir, yokedilir veya anonim hale
                  getirilir.
                </p>
              </div>
              <div>
                <h4 className="text-gray-900 font-semibold">İLETİŞİM İZNİ</h4>
                <p className="text-xs md:text-sm">
                  Veri sahibinin Şirketimiz ile paylaşmış olduğu Kişisel
                  Veriler; hizmetlerimizin içerik ve tanıtımlarımızın
                  geliştirilmesi ve kişileştirilmesi veya yeni hizmetler
                  sunabilmek amacıyla ve her türlü iletişim mesajlarının
                  gönderilmesi amacıyla Şirketimizce kullanabilir. Bu veriler,
                  aynı zamanda sadece sözleşme ilişkisi içinde olduğumuz, veri
                  güvenliği konusundaki hassasiyetimizi paylaşan, ilgili mevzuat
                  hükümlerine riayet eden 3. kişilerle, yalnızca ihtiyaç
                  durumunda ve gerekli ölçüde paylaşılacaktır. Veri sahibi, bu
                  tanıtımları almamak veya söz konusu reklam-kişiselleştirme,
                  yeniden hedefleme uygulamalarında yer almak istemediği
                  takdirde, taleplerini her zaman internet sitesinde yer alan
                  iletişim bilgilerinden Şirketimiz’e ulaşarak da iletebilir.
                </p>
              </div>
              <div>
                <h4 className="text-gray-900 font-semibold">
                  GİZLİLİK VE VERİ KORUMA POLİTİKASI
                </h4>
                <p className="text-xs md:text-sm">
                  3İK İLETİŞİM AJANSI DANIŞMANLIK TASARIM VE ORGANİZASYON
                  HİZ.TİC.LTD.ŞTİ, NİSBETİYE MAH. AYDIN SOK. DAĞLI İŞ MERKEZİ
                  BLOK NO:4 İÇ KAPI NO:6 BEŞİKTAŞ/İSTANBUL adresinde mukim,
                  0730036903500001 mersis no’lu Beşiktaş Vergi Dairesi, 730 036
                  9035 no’lu vergi mükellefi, 3İK İLETİŞİM AJANSI DANIŞMANLIK
                  TASARIM VE ORGANİZASYON HİZ.TİC.LTD.ŞTİ (“3İK Marka İletişim
                  Ajansı”) olarak; veri sorumlusu sıfatıyla, ticari
                  ilişkilerimiz kapsamında veya sizlerle olan iş ilişkimiz
                  dahilinde, kişisel verilerinizin, işlenmelerini gerektiren
                  amaç çerçevesinde ve bu amaç ile bağlantılı, sınırlı ve ölçülü
                  şekilde, tarafımıza bildirdiğiniz veya bildirildiği şekliyle
                  kişisel verilerin doğruluğunu ve en güncel halini koruyarak,
                  kaydedileceğini, depolanacağını, muhafaza edileceğini, yeniden
                  düzenleneceğini, kanunen bu kişisel verileri talep etmeye
                  yetkili olan kurumlar ile paylaşılacağını, yurtiçi veya
                  yurtdışı üçüncü kişilere aktarılacağını, devredileceğini,
                  sınıflandırılabileceğini ve Kişisel Verileri Koruma Kanunu’nda
                  (Bundan sonra  “KVKK” olarak anılacaktır) sayılan sair
                  şekillerde işlenebileceğini bildiririz; Aşağıda belirttiğimiz
                  ve tarafımıza sağladığınız kişisel verilerinizin her koşulda;
                  duruma göre aşağıda belirtilen şekillerde elde ettiğimiz
                  kişisel verilerinizin hukuki ilişkilerimiz kapsamında,
                  İşlenmelerini gerektiren amaç çerçevesinde ve bu amaçla
                  bağlantılı, sınırlı ve ölçülü şekilde, Tarafımıza
                  bildirdiğiniz veya bildirildiği şekliyle kişisel verilerin
                  doğruluğunu ve en güncel halini koruyarak, Kaydedileceğini,
                  depolanacağını, muhafaza edileceğini, yeniden düzenleneceğini,
                  kanunen bu kişisel verileri talep etmeye yetkili olan kurumlar
                  ile paylaşılacağını ve KVKK’nın öngördüğü şartlarda,
                  yurtiçinde üçüncü kişilere aktarılacağını, devredileceğini,
                  sınıflandırılabileceğini ve KVKK’da sayılan sair şekillerde
                  işlenebileceğini bildiririz.
                </p>
              </div>
              <div>
                <h4 className="text-gray-900 font-semibold">
                  KİŞİSEL VERİLERİNİZİ HANGİ AMAÇLARLA İŞLİYORUZ?
                </h4>
                <p className="text-xs md:text-sm">
                  Anayasa, İş Kanunu, İş Sağlığı ve Güvenliği Kanunu, İş Sağlığı
                  ve Güvenliği Hizmetleri Yönetmeliği, Türk Borçlar Kanunu, Türk
                  Medeni Kanunu ve diğer ilgili mevzuatlar çerçevesinde ve
                  Hayat’ı Keşfet Staj Programı’na yaptığınız başvuru
                  çerçevesinde kariyer programına katılım için yetkinlik
                  değerlendirmesi süreçlerine ilişkin meşru menfaat gibi hukuki
                  sebeplere dayanılarak; katılımcıların belirlenmesi, katılımcı
                  kitlesinin analizi, daha sonraki kariyer programları için
                  fikir oluşturması ya da katılımcı listelerinin oluşturulması
                  çalışmaları amacıyla fotoğraf ve görüntülerinizin işlenmesine
                  ilişkin süreçlerin yürütülmesi gibi amaçlarla 3İK Marka
                  İletişim Ajansı, özel nitelikli kişisel verileriniz de dahil
                  olmak üzere, yukarıda belirtilen çerçevede elde edilen kişisel
                  verileriniz, yalnızca KVKK’ nın 5. ve 6. maddelerinde
                  belirtilen kişisel veri işleme şartları çerçevesinde
                  işlenebilir.
                </p>
              </div>
              <div>
                <h4 className="text-gray-900 font-semibold">HAKLARINIZ</h4>
                <p className="text-xs md:text-sm">
                  Veri sahibi, işlenen Kişisel Verileri’nin neler olduğunu ve
                  işlenip işlenmediğini, işleme amacı doğrultusunda kullanılıp
                  kullanılmadığını öğrenebilir, verileri işlenmişse bu hususta
                  bilgi talep edebilir, yurt içi veya yurt dışında Kişisel
                  Veriler’in aktarıldığı üçüncü kişileri öğrenebilir, eksik veya
                  yanlış işlenen Kişisel Veriler söz konusu ise veya işlenen
                  Kişisel Verileri’nde herhangi bir değişiklik olması durumunda
                  bu verilerin düzeltilmesini, değiştirilmesini,
                  güncellenmesini, KVKK’nın 7. maddesinde öngörülen şartlar
                  çerçevesinde silinmesini/yok edilmesini veya anonim hale
                  getirilmesini, bu işlemlerin (eksik veya yanlış işlenen
                  Kişisel Verileri söz konusu ise, bu verilerin düzeltilmesini
                  veya KVKK’nın 7. maddesinde öngörülen şartlar çerçevesinde
                  silinmesini/yok edilmesini veya anonim hale getirilmesini)
                  Kişisel Veriler’in aktarıldığı üçüncü kişilere bildirilmesini
                  talep edebilir; işlenen verilerin münhasıran otomatik
                  sistemler ile analiz edilmesi nedeniyle aleyhine bir sonucun
                  ortaya çıkmasına itiraz edebilir ve Kişisel Veriler’in kanuna
                  aykırı olarak işlenmesi sebebiyle zarara uğraması hâlinde
                  zararın giderilmesini talep edebilir. Kullanıcı/Üye, bu
                  kapsamdaki haklarını KVKK md. 11 uyarınca:
                </p>
                <ul className="text-xs md:text-sm list-disc pl-10">
                  <li>
                    3İK Marka İletişim Ajansı’nın hakkınızda kişisel veri
                    işleyip işlemediğini öğrenmek, eğer işlemişse, buna ilişkin
                    bilgi talep etmek,
                  </li>
                  <li>
                    Kişisel verilerinizin işlenme amacını ve bunların amacına
                    uygun kullanılıp kullanılmadığı öğrenmek,
                  </li>
                  <li>
                    Kişisel verilerin yurtiçi veya yurtdışına aktarılıp
                    aktarılmadığı ve kimlere aktarıldığını öğrenmek haklarına
                    sahipsiniz.
                  </li>
                  <li>
                    Ayrıca, 3İK Marka İletişim Ajansı’ndan yanlış ve eksik
                    kişisel verilerinizin düzeltilmesini ve verilerinin
                    aktarıldığı veya aktarılmış olabileceği alıcıların
                    bilgilendirilmesini talep etme hakkınız vardır.
                  </li>
                </ul>
                <p className="text-xs md:text-sm">
                  Kişisel verilerinizin KVKK madde 7’de öngörülen şartlar
                  çerçevesinde verilerinizin imha edilmesini (silinmesini, yok
                  edilmesini veya anonim hale getirilmesini) 3İK Marka İletişim
                  Ajansı’ndan talep edebilirsiniz. Aynı zamanda verilerin
                  aktarıldığı veya aktarılabileceği 3. kişilerin söz konusu imha
                  talebiniz ile ilgili bilgilendirilmesini talep edebilirsiniz.
                  Ancak imha talebinizi değerlendirerek hangi yöntemin uygun
                  olduğu somut olayın koşullarına göre tarafımızca
                  değerlendirilecektir. Bu bağlamda seçtiğimiz imha yöntemini
                  neden seçtiğimiz ile ilgili bizden her zaman bilgi talep
                  edebilirsiniz. Münhasıran bir otomatik sistem kullanılarak
                  oluşturulmuş kişisel veri analizinizin sonuçlarına bu sonuçlar
                  çıkarlarınıza aykırıysa itiraz edebilirsiniz. Kişisel
                  verilerinizin kanuna aykırı olarak işlenmesi sebebiyle zarara
                  uğramanız halinde zararın giderilmesini talep edebilirsiniz.
                  Başvurunuzda yer alan talepleriniz, talebin niteliğine göre en
                  geç otuz gün içinde ücretsiz olarak sonuçlandırılacaktır.
                  Ancak, işlemin 3İK Marka İletişim Ajansı için ayrıca bir
                  maliyeti gerektirmesi hâlinde, Kişisel Verileri Koruma Kurulu
                  tarafından Veri Sorumlusuna Başvuru Usul ve Esasları Hakkında
                  Tebliğ’de belirlenen tarifedeki ücret alınabilir. <br />
                  Kişisel verilerinizin işlenmesi ile ilgili hususlarda
                  başvurunuzu, bu Aydınlatma Metni’ nin ekinde yer alan başvuru
                  formunu doldurarak, yazılı olarak veya kayıtlı elektronik
                  posta (KEP) adresi, güvenli elektronik imza, mobil imza ya da
                  bize daha önce bildirdiğiniz ve kayıtlarımızda yer alan
                  elektronik posta adresinizi kullanmak suretiyle 3İK Marka
                  İletişim Ajansı’na teslim etmeniz gerekmektedir. 3İK Marka
                  İletişim Ajansı tarafından talebinizin mahiyetine ve başvuru
                  yönteminize göre 3İK Marka İletişim Ajansı tarafından
                  başvurunun size ait olup olmadığının belirlenmesi ve böylece
                  haklarınızı koruyabilmek amacıyla ek doğrulamalar (kayıtlı
                  telefonunuza mesaj gönderilmesi, aranmanız gibi) istenebilir.
                  Örneğin 3İK Marka İletişim Ajansı’nda kayıtlı olan e-posta
                  adresiniz aracılığıyla başvuru yapmanız halinde 3İK Marka
                  İletişim Ajansı’nda kayıtlı başka bir iletişim yöntemini
                  kullanarak size ulaşabilir ve başvurunun size ait olup
                  olmadığının teyidini isteyebiliriz.
                </p>
              </div>
              <div>
                <h4 className="text-gray-900 font-semibold">
                  KİŞİSEL VERİ SAKLAMA SÜRESİ
                </h4>
                <p className="text-xs md:text-sm">
                  Şirketimiz, KVKK uyarınca işlediği Kişisel Verileri yalnızca
                  ilgili mevzuatta öngörülen veya mevzuatta bir süre
                  öngörülmemiş ise kişisel veri işleme amacının gerektirdiği
                  süre kadar muhafaza eder. Tutulan veriler verinin işlenmesini
                  gerektiren sebepler sona erdikten sonra silinir, yok edilir
                  veya anonim hale getirilir. Örnek vermek gerekirse 6563 Sayılı
                  Elektronik Ticaretin Düzenlenmesi Hakkında Kanun ile buna
                  bağlı yönetmelik uyarınca Kişisel Veriler’in pazarlama veya
                  tanıtım amaçları için kullanılacağına ilişkin veri sahibinin
                  onayının geri alındığı durumlarda, Kişisel Veriler’in
                  kayıtları bu tarihten itibaren 1 yıl saklanır. Ticari
                  elektronik iletinin içeriği ve gönderiye ilişkin diğer her
                  türlü kayıt ise gerektiğinde ilgili bakanlığa sunulmak üzere 3
                  yıl saklanır. 5651 Sayılı İnternet Ortamında Yapılan
                  Yayınların Düzenlenmesi ve Bu Yayınlar Yoluyla İşlenen
                  Suçlarla Mücadele Edilmesi Hakkında Kanun uyarınca ise
                  işlediğimiz trafik verileri 2 yıl saklanır ve süre bittikten
                  sonra anonim hale getirilir. Her halükarda Kişisel Veriler’in
                  birden fazla sebeple işlenmiş olması halinde, söz konusu
                  verinin işlenmesini gerektiren tüm nedenler ortadan
                  kalktığında ilgili veri silinir, yok edilir veya anonim hale
                  getirilir.
                </p>
              </div>
              <div>
                <h4 className="text-gray-900 font-semibold">
                  KİŞİSEL VERİLERİNİZİN KORUNMASINA İLİŞKİN ÖNLEMLER
                </h4>
                <p className="text-xs md:text-sm">
                  Kişisel Veriler’in korunması Şirketimiz için önemli bir
                  konudur. Kişisel Veriler’e yetkisiz erişim veya bu bilgilerin
                  kaybı, hatalı kullanımı, ifşa edilmesi, değiştirilmesi veya
                  imha edilmesine karşı veri sahibini korumak için gerekli
                  teknik ve idari her türlü önlemi almaktayız. Kişisel Veriler’i
                  işlerken genel kabul görmüş güvenlik teknolojisi
                  standartlarını kullanmaktayız. Kişisel Veriler’i gizli
                  tutmayı, gizliliğin sağlanması ve güvenliği için gerekli
                  teknik ve idari her türlü tedbiri almayı ve gerekli özeni
                  göstermeyi taahhüt etmekteyiz. Gerekli bilgi güvenliği
                  önlemlerini almamıza karşın, Şirketimiz’e ait internet
                  sitesine ve sisteme yapılan saldırılar sonucunda Kişisel
                  Veriler’in zarar görmesi veya üçüncü kişilerin eline geçmesi
                  durumunda, bu durumu derhal sizlere ve Kişisel Verileri Koruma
                  Kurulu’na bildirir ve gerekli önlemleri alırız.
                </p>
              </div>
              <div>
                <h4 className="text-gray-900 font-semibold">
                  UYGULANACAK HUKUK, YETKİLİ MAHKEME VE İCRA DAİRELERİ
                </h4>
                <p className="text-xs md:text-sm">
                  İşbu Gizlilik, Kişisel Verilerin Korunması ve Çerez
                  Politikası, Türkiye Cumhuriyeti kanunlarına tabidir. Gizlilik,
                  Kişisel Verilerin Korunması ve Çerez Politikası’nın
                  uygulanmasından doğabilecek her türlü uyuşmazlığın çözümünde
                  İstanbul Çağlayan Mahkeme ve İcra Daireleri yetkilidir.
                </p>
              </div>
              <div>
                <h4 className="text-gray-900 font-semibold">İLETİŞİM İZNİ</h4>
                <p className="text-xs md:text-sm">
                  Veri sahibinin Şirketimiz ile paylaşmış olduğu Kişisel
                  Veriler; hizmetlerimizin içerik ve tanıtımlarımızın
                  geliştirilmesi ve kişileştirilmesi veya yeni hizmetler
                  sunabilmek amacıyla ve her türlü iletişim mesajlarının
                  gönderilmesi amacıyla Şirketimizce kullanabilir. Bu veriler,
                  aynı zamanda sadece sözleşme ilişkisi içinde olduğumuz, veri
                  güvenliği konusundaki hassasiyetimizi paylaşan, ilgili mevzuat
                  hükümlerine riayet eden 3. kişilerle, yalnızca ihtiyaç
                  durumunda ve gerekli ölçüde paylaşılacaktır. Veri sahibi, bu
                  tanıtımları almamak veya söz konusu reklam-kişiselleştirme,
                  yeniden hedefleme uygulamalarında yer almak istemediği
                  takdirde, taleplerini her zaman internet sitesinde yer alan
                  iletişim bilgilerinden Şirketimiz’e ulaşarak da iletebilir.
                </p>
              </div>
            </div>
            <div className="modal-footer flex flex-shrink-0 flex-wrap items-center justify-end p-4 border-t border-gray-200 rounded-b-md">
              <button
                type="button"
                className="px-4 py-2 mr-2 bg-red-500 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-red-600 hover:shadow-lg focus:bg-red-600 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-red-600 active:shadow-lg transition duration-150 ease-in-out"
                data-bs-dismiss="modal"
              >
                Kapat
              </button>
              <label
                htmlFor={!props.isChecked ? "aydinlatma-metni" : ""}
                data-bs-dismiss="modal"
                className="px-4 py-2 bg-green-500 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-green-600 hover:shadow-lg focus:bg-green-600 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-green-600 active:shadow-lg transition duration-150 ease-in-out cursor-pointer"
              >
                Onaylıyorum
              </label>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AydinlatmaMetni;
